(function ($) {
	"use strict";
	let blockWheelsProgressBar = {
		initAll: function () {

			const elementList = document.querySelectorAll('.wp-block-blockwheels-progress-bar');

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Progress Bar
			[...elementList].forEach((progress) => {
				let lineId 		= $(progress).data('id'),
					number 		= $(progress).find('.blockwheels-progress-bar-line').data('number'),
					thickness 	= $(progress).find('.blockwheels-progress-bar-line').data('thickness'),
					labelColor 	= $(progress).find('.blockwheels-progress-bar-line').data('label'),
					bgColor 	= $(progress).find('.blockwheels-progress-bar-line').data('background'),
					baseBgColor = $(progress).find('.blockwheels-progress-bar-line').data('base');

				let lineProgressBar = new ProgressBar.Line('#line-' + lineId, {
					strokeWidth: thickness/2,
					easing: 'easeInOut',
					duration: 1400,
					color: bgColor,
					trailColor: baseBgColor,
					trailWidth: thickness/2,
					svgStyle: {width: '100%', height: '100%', maxHeight: thickness + 'px'},
					text: {
						style: {
						  // Text color.
						  // Default: same as stroke color (options.color)
						  color: labelColor,
						  position: 'absolute',
						  right: '0',
						  top: '30px',
						  padding: 0,
						  margin: 0,
						  transform: null
						},
						autoStyleContainer: false
					},
					from: {color: bgColor},
					to: {color: baseBgColor},
					step: (state, bar) => {
					bar.setText(Math.round(bar.value() * 100) + '%');
					}
				});
				lineProgressBar.set(0);
				let controller = new ScrollMagic.Controller();
				let desiredAnimation = new ScrollMagic.Scene({triggerElement: '#line-' + lineId, duration: 200});
				desiredAnimation.addTo(controller);
				desiredAnimation.on("enter", function (e) {
					lineProgressBar.animate(number);  // Number from 0.0 to 1.0
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockWheelsProgressBar.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockWheelsProgressBar.init);
	} else {
		// The DOM has already been loaded.
		blockWheelsProgressBar.init();
	}
})(jQuery);